(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["color-swatches"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.color-swatches').forEach((container) => {
  const valueHolder = container.querySelector('.selected-color');
  const hiddenInput = container.querySelector('.color-swatches-hidden');
  if (!hiddenInput) return;

  container.addEventListener('change', (event) => {
    if (event.target.type === 'radio') {
      hiddenInput.value = event.target.value;
      if (valueHolder) valueHolder.textContent = event.target.value;
    }
  });
});


document.addEventListener("DOMContentLoaded", function () {

  const productWrapper = document.querySelector('[data-product-template="new-ring"]');
  if (!productWrapper) return;

  const radios = productWrapper.querySelectorAll('.color-swatches input[type="radio"]');

  function switchImage(radio){

    const selectedColor = radio.value.toLowerCase().replace(/\s+/g, '-');

    const slides = document.querySelectorAll('.protopimg-item');

    let targetSlide = null;

    slides.forEach((slide) => {

      const img = slide.querySelector('img');
      if (!img) return;

      const alt = img.alt.toLowerCase();

      if (alt.includes(selectedColor) && !targetSlide) {
        targetSlide = slide;
      }

    });

    if (!targetSlide) return;

    const thumbnail = document.querySelector(
      `[data-target="${targetSlide.dataset.mediaId}"]`
    );

    if (thumbnail) {
      thumbnail.querySelector('button').click();
    }

  }

  radios.forEach((radio) => {

    radio.addEventListener('change', function () {
      switchImage(this);
    });

  });

  // run once on page load
  const checkedRadio = productWrapper.querySelector('.color-swatches input[type="radio"]:checked');
  if (checkedRadio) {
    switchImage(checkedRadio);
  }

});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["diamond-shape-swatches"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.diamond-shape-swatches').forEach((container) => {
  const valueHolder = container.querySelector('.selected-shape');
  const hiddenInput = container.querySelector('.diamond-shape-hidden');
  if (!hiddenInput) return;

  container.addEventListener('change', (event) => {
    if (event.target.type === 'radio') {
      hiddenInput.value = event.target.value;
      if (valueHolder) valueHolder.textContent = event.target.value;
    }
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["engraving-input"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.engraving-input-block').forEach((container) => {
  const input = container.querySelector('.engraving-input');
  const counter = container.querySelector('.current-count');
  if (!input || !counter) return;

  input.addEventListener('input', () => {
    counter.textContent = input.value.length;
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ring-size-dropdown"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.ring-size-dropdown').forEach((container) => {
  const select = container.querySelector('.ring-size-select');
  const hiddenInput = container.querySelector('.ring-size-hidden');
  const valueHolder = container.querySelector('.selected-size');

  if (!select || !hiddenInput) return;

  select.addEventListener('change', () => {
    hiddenInput.value = select.value;
    if (valueHolder) valueHolder.textContent = select.value;
  });
});
  } catch(e) { console.error(e); }
})();

})();
